import DataRoomFolder from './DataRoomFolder.component';

export default DataRoomFolder;